/**
 * DeliveryRequest
 * @author gabrielbgil
 */
import {
  Resource,
  Collection,
  $,
} from 'simpli-web-sdk'
import Responsavel from '@/model/resource/Responsavel'
import ResponsavelConfigWhatsapp from '@/model/resource/ResponsavelConfigWhatsapp'

export default class ResponsavelConfigWhatsappRequest extends Resource {
  readonly $name: string = 'ResponsavelConfigWhatsappRequest'
  readonly $endpoint = '/user/config-whatsapp/configuracao{/id}'
  $id = 0

  responsavel: Responsavel | null = null
  list: ResponsavelConfigWhatsapp[] = []

  async populate(spinner = 'populateResponsavelConfigWhatsappRequest') {
    const collection = new Collection(ResponsavelConfigWhatsapp)
    await $.await.run(() => collection.query(), spinner)
    this.list = collection.items
  }
}
